export const classes = {
  icon: 'inline-block size-3',
};
